import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export const toastAlert = {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  methods: {
    toastAlert({
      title = 'Error!',
      icon = 'XIcon',
      variant = 'error',
      text = '',
    }) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
          text,
        },

      })
    },
  },
}

export const _ = null
